import * as fromDatatype from '../datatype-library/index'

export interface bl_fi_item_to_mrp_prodsys_link_RowInterface {
    guid: fromDatatype.GuidDataFieldInterface;
    guid_mrp_prodsys_hdr: fromDatatype.GuidDataFieldInterface;
    guid_fi_item_hdr: fromDatatype.GuidDataFieldInterface;
    code: fromDatatype.VarcharDatatypeInterface;
    name: fromDatatype.VarcharDatatypeInterface;
    descr: fromDatatype.TextDatatypeInterface;
    module_guid: fromDatatype.GuidDataFieldInterface;
    applet_guid: fromDatatype.GuidDataFieldInterface;
    namespace: fromDatatype.VarcharDatatypeInterface;
    acl_config: fromDatatype.JsonDatatypeInterface;
    acl_policy: fromDatatype.JsonDatatypeInterface;
    created_date: fromDatatype.TimestampTzDatatypeInterface;
    updated_date: fromDatatype.TimestampTzDatatypeInterface;
    created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
    updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
    revision:fromDatatype.RevisionDataFieldInterface;
    status: fromDatatype.StatusDataFieldInterface;
    vrsn: fromDatatype.VrsnDataFieldInterface;
}


export class bl_fi_item_to_mrp_prodsys_link_RowClass implements bl_fi_item_to_mrp_prodsys_link_RowInterface
  {
    guid: fromDatatype.GuidDataFieldInterface;
    guid_mrp_prodsys_hdr: fromDatatype.GuidDataFieldInterface;
    guid_fi_item_hdr: fromDatatype.GuidDataFieldInterface;
    code: fromDatatype.VarcharDatatypeInterface;
    name: fromDatatype.VarcharDatatypeInterface;
    descr: fromDatatype.TextDatatypeInterface;
    module_guid: fromDatatype.GuidDataFieldInterface;
    applet_guid: fromDatatype.GuidDataFieldInterface;
    namespace: fromDatatype.VarcharDatatypeInterface;
    acl_config: fromDatatype.JsonDatatypeInterface;
    acl_policy: fromDatatype.JsonDatatypeInterface;
    created_date: fromDatatype.TimestampTzDatatypeInterface;
    updated_date: fromDatatype.TimestampTzDatatypeInterface;
    created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
    updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
    revision:fromDatatype.RevisionDataFieldInterface;
    status: fromDatatype.StatusDataFieldInterface;
    vrsn: fromDatatype.VrsnDataFieldInterface;
}
